/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Aria_EditInputs */

const vi_common_aria_edit = /** @type {(inputs: Common_Aria_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sửa`)
};

/**

* @param {Common_Aria_EditInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const common_aria_edit = /** @type {((inputs?: Common_Aria_EditInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Aria_EditInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_common_aria_edit(inputs)
});